import React, { useMemo, useState } from 'react';
import { Box, Grid, Typography, alpha, styled } from '@mui/material';
import PayByCash from './PayByCash';
import Refund from './Refund';
import { useSelector } from 'react-redux';
import { RootStateType } from '@Store';
import { isActionAllowed } from '../../../../utils/allowedActions';
import { ACTION_NAMES, PERFORM_ACTION } from '@Constants/actionsNames';
import { ShipmentControl } from '@Services/shipmentActionControl';

type PaymentOptions = 'cash' | 'refund';

function PaymentOptionSelections() {
  const shipmentById = useSelector((state: RootStateType) => state.adminShipment.shipmentById);
  const shipmentActionControl = new ShipmentControl(shipmentById);
  const shipmentpayment = useSelector((state: RootStateType) => state.adminShipment.shipmentpayment);
  const { payableAmount, totalPaidAmt, amount, tdsAmount = 0 } = shipmentpayment || {};

  const [paymentOptions, setPaymentOption] = useState<PaymentOptions | null>(null);

  const { menuAcccessGroupById: accessGroupById } = useSelector((state: RootStateType) => state.accessGroup);

  const isPaymentWriteAllowed = isActionAllowed(
    accessGroupById?.actions,
    ACTION_NAMES.Single_Shipment_View_OR_Processing.payment,
    PERFORM_ACTION.write,
  );
  const canRedund = useMemo(() => {
    if (shipmentpayment?._transactionsId.length) {
      return shipmentpayment._transactionsId.some(t => t.mode === 'wallet' || t.mode === 'cash');
    }
  }, [shipmentpayment?._transactionsId]);

  return (
    <Box sx={{ width: '100%' }}>
      {shipmentActionControl.canDoPayment && (
        <>
          {paymentOptions === null && (
            <Box sx={{ mb: 1.5 }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'common.black' }}>
                Select Payment Mode
              </Typography>
            </Box>
          )}
          {!paymentOptions && (
            <Grid container>
              <PaymentSingleOption
                className={`${
                  !shipmentById?.isInvoiceGenerated &&
                  isPaymentWriteAllowed &&
                  payableAmount &&
                  shipmentById?._accountId?.isPrepaid &&
                  payableAmount - tdsAmount > 0
                    ? 'cursor-pointer'
                    : 'disabled-form cursor-not-allowed'
                } `}
                onClick={() => {
                  if (
                    !shipmentById?.isInvoiceGenerated &&
                    shipmentById?._accountId?.isPrepaid &&
                    isPaymentWriteAllowed &&
                    payableAmount &&
                    payableAmount - tdsAmount > 0
                  ) {
                    setPaymentOption('cash');
                  }
                }}
              >
                Pay by Cash
              </PaymentSingleOption>
              {/* <PaymentSingleOption
                className={`${
                  (!shipmentById?.isInvoiceGenerated &&
                    isPaymentWriteAllowed &&
                    canRedund &&
                    payableAmount &&
                    payableAmount < 0) ||
                  (shipmentById?.status === 'cancelled' &&
                    shipmentById?._accountId.isPrepaid &&
                    shipmentById?.paidAmount > 0)
                    ? 'cursor-pointer'
                    : 'disabled-form cursor-not-allowed'
                } mt-1`}
                onClick={() => {
                  if (
                    (!shipmentById?.isInvoiceGenerated &&
                      isPaymentWriteAllowed &&
                      canRedund &&
                      payableAmount &&
                      payableAmount < 0) ||
                    (shipmentById?.status === 'cancelled' &&
                      shipmentById?._accountId.isPrepaid &&
                      shipmentById?.paidAmount > 0)
                  ) {
                    setPaymentOption('refund');
                  }
                }}
              >
                Refund
              </PaymentSingleOption> */}
              {/* <PaymentSingleOption
                className={`${
                  (!shipmentById?.isInvoiceGenerated &&
                    isPaymentWriteAllowed &&
                    canRedund &&
                    payableAmount &&
                    payableAmount < 0) ||
                  (shipmentById?.status === 'cancelled' &&
                    shipmentById?._accountId.isPrepaid &&
                    shipmentById?.paidAmount > 0) ||
                  (Number(totalPaidAmt) ?? 0) > (amount ?? 0)
                    ? 'cursor-pointer'
                    : 'disabled-form cursor-not-allowed'
                } mt-1`}
                onClick={() => {
                  if (
                    (!shipmentById?.isInvoiceGenerated &&
                      isPaymentWriteAllowed &&
                      canRedund &&
                      payableAmount &&
                      payableAmount < 0) ||
                    (shipmentById?.status === 'cancelled' &&
                      shipmentById?._accountId.isPrepaid &&
                      shipmentById?.paidAmount > 0) ||
                    (Number(totalPaidAmt) ?? 0) > (amount ?? 0)
                  ) {
                    setPaymentOption('refund');
                  }
                }}
              >
                Refund
              </PaymentSingleOption> */}
              <PaymentSingleOption
                className={`${
                  shipmentById?.invoiceNumber
                    ? 'disabled-form cursor-not-allowed'
                    : (Number(totalPaidAmt) ?? 0) > (amount ?? 0) ||
                      (!shipmentById?.isInvoiceGenerated &&
                        isPaymentWriteAllowed &&
                        canRedund &&
                        payableAmount &&
                        payableAmount - tdsAmount < 0) ||
                      ((shipmentById?.status === 'cancelled' || shipmentById?.status === 'void') &&
                        shipmentById?._accountId.isPrepaid &&
                        shipmentById?.paidAmount > 0)
                    ? 'cursor-pointer'
                    : 'disabled-form cursor-not-allowed'
                } mt-1`}
                onClick={() => {
                  if (
                    !shipmentById?.invoiceNumber &&
                    ((Number(totalPaidAmt) ?? 0) > (amount ?? 0) ||
                      (!shipmentById?.isInvoiceGenerated &&
                        isPaymentWriteAllowed &&
                        canRedund &&
                        payableAmount &&
                        payableAmount - tdsAmount < 0) ||
                      ((shipmentById?.status === 'cancelled' || shipmentById?.status === 'void') &&
                        shipmentById?._accountId.isPrepaid &&
                        shipmentById?.paidAmount > 0))
                  ) {
                    setPaymentOption('refund');
                  }
                }}
              >
                Refund
              </PaymentSingleOption>
            </Grid>
          )}
        </>
      )}
      {paymentOptions === 'cash' && <PayByCash onCancel={() => setPaymentOption(null)} />}
      {paymentOptions === 'refund' && <Refund onCancel={() => setPaymentOption(null)} />}
    </Box>
  );
}

const PaymentSingleOption = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: '12px',
  width: '100%',

  // Glass effect
  backdropFilter: 'blur(16px)',
  WebkitBackdropFilter: 'blur(16px)',
  background: alpha(theme.palette.common.white, 0.7),
  border: `1px solid ${alpha(theme.palette.common.white, 0.3)}`,

  boxShadow: `
    0px 2px 4px rgba(156, 156, 156, 0.15),
    0px 8px 32px rgba(31, 38, 135, 0.08)
  `,

  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

  '&:hover': {
    background: alpha(theme.palette.primary.light, 0.18),
    border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
    boxShadow: `
      0px 4px 12px rgba(156, 156, 156, 0.2),
      0px 12px 40px rgba(31, 38, 135, 0.12)
    `,
    transform: 'translateY(-2px)',
  },
}));

export default PaymentOptionSelections;
